/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { deploymentsActive } from "../funcs/deploymentsActive.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetActiveDeploymentResult } from "../models/components/getactivedeploymentresult.js";
import {
  GetActiveDeploymentRequest,
  GetActiveDeploymentSecurity,
} from "../models/operations/getactivedeployment.js";
import { unwrapAsync } from "../types/fp.js";
export type ActiveDeploymentQueryData = GetActiveDeploymentResult;

export function prefetchActiveDeployment(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetActiveDeploymentRequest | undefined,
  security?: GetActiveDeploymentSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildActiveDeploymentQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildActiveDeploymentQuery(
  client$: GramCore,
  request?: GetActiveDeploymentRequest | undefined,
  security?: GetActiveDeploymentSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ActiveDeploymentQueryData>;
} {
  return {
    queryKey: queryKeyActiveDeployment({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function activeDeploymentQueryFn(
      ctx,
    ): Promise<ActiveDeploymentQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(deploymentsActive(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyActiveDeployment(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "deployments", "active", parameters];
}
